export const VTA_LOOKBACK_WINDOW_INPUT_TYPE = {
    HOURS: 'HOURS',
    DAYS: 'DAYS',
};
